const agentApplicationPathPrefixes = [
  "/agent",
  "/share/agent",
  "/share/registry",
];

const agentApplicationExactPaths = new Set(["/cli-auth", "/oauth/authorize"]);

export function isAgentApplicationPath(pathname: string) {
  return (
    agentApplicationExactPaths.has(pathname) ||
    agentApplicationPathPrefixes.some((pathPrefix) => {
      return pathname === pathPrefix || pathname.startsWith(`${pathPrefix}/`);
    })
  );
}
